import React from "react";
import { Controller, useForm } from "react-hook-form";
import Input from "../global/Input";
import ValidateError from "../global/ValidateError";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";
import Button from "../global/Button";
import { toast } from "react-toastify";
import { EmailValidate, toastMessage } from "../../utils/utils";
import {
  useResetPasswordEmailConfirmMutation,
  useResetPasswordMutation,
} from "../../lib/redux/services/Api";
import { useNavigate } from "react-router-dom";
type FormInput = {
  email: string;
};
const ForgetPasswordEmailConfirm = () => {
  const navigate = useNavigate();
  const { Auth, shared, inputs }: DictionaryType = useGetDictionary();
  const [resetPasswordRequest] = useResetPasswordEmailConfirmMutation();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormInput>();
  const onSubmit = async (formData: FormInput) => {
    try {
      const data = await toast.promise(
        resetPasswordRequest({
          ...formData,
          email: formData?.email?.toLowerCase(),
        }).unwrap(),
        toastMessage()
      );
      //  {
      //   state: { email: formData.email },
      // }
      navigate("/auth/email-confirmation", {
        state: { email: formData.email },
      });
    } catch (error) {
      console.error("Login error:", error);
    }
  };
  return (
    <div>
      {" "}
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="space-y-4 md:space-y-6 max-w-[814px] px-5 py-5"
      >
        <div className="mt-6 flex text-start flex-col items-center justify-center gap-6 w-full">
          <div className="w-full">
            <Controller
              name="email"
              rules={{
                required: true,
                pattern: {
                  value: EmailValidate,
                  message: shared.Invalid_email_domain_messsage,
                },
              }}
              control={control}
              render={({ field }) => (
                <Input
                  inputProps={{
                    ...field,
                    type: "text",
                  }}
                  label={inputs.email}
                />
              )}
            />
            {errors.email && (
              <ValidateError errorMessage={errors.email.message} />
            )}
          </div>
        </div>
        <div className="flex flex-row w-full gap-2">
          <Button
            customeStyle="bg-white text-primaryRed border border-primaryRed w-full rounded-full text-sm py-3 font-bold"
            text={shared.cancel}
            width="max-w-[350px] w-full"
            type="button"
            href="/auth/login"
          />
          <Button
            customeStyle="bg-primary text-white w-full rounded-full text-sm py-3 font-bold"
            text={shared.confirm}
            width="max-w-[350px] w-full"
            type="submit"
          />
        </div>
      </form>
    </div>
  );
};

export default ForgetPasswordEmailConfirm;
